import { withTitleCasedDrugFields } from 'common/utils/titleCase';
import graphqlClient from '../graphql';
import { createCoaUploadUrlGql, listCoaDocumentsGql, listCoaEligibleLotsGql } from './gql';

export const COA_CONTENT_TYPE = 'application/pdf';

export const listCoaDocumentsApi = () =>
  graphqlClient
    .request(listCoaDocumentsGql)
    .then(({ listCoaDocuments }) => (listCoaDocuments ?? []).map(withTitleCasedDrugFields));

export const listCoaEligibleLotsApi = () =>
  graphqlClient
    .request(listCoaEligibleLotsGql)
    .then(({ listCoaEligibleLots }) => (listCoaEligibleLots ?? []).map(withTitleCasedDrugFields));

export const createCoaUploadUrlApi = ({ ndc, lotNumber }) =>
  graphqlClient
    .request(createCoaUploadUrlGql, { input: { ndc, lotNumber } })
    .then(({ createCoaUploadUrl }) => createCoaUploadUrl);

/**
 * PUTs the PDF straight to S3 with the presigned URL from createCoaUploadUrl. The URL was signed
 * for `application/pdf`, so the request must carry exactly that Content-Type or S3 rejects it.
 */
export const putCoaFileApi = ({ uploadUrl, file }) =>
  fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': COA_CONTENT_TYPE },
    body: file,
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Upload to S3 failed (${response.status} ${response.statusText})`);
    }
    return response;
  });

/**
 * Full upload: ask core for a presigned URL (which also enforces that the NDC/lot is in
 * inventory), then PUT the file. Resolves to the upload config so callers can link to the file.
 */
export const uploadCoaApi = async ({ ndc, lotNumber, file }) => {
  const config = await createCoaUploadUrlApi({ ndc, lotNumber });
  await putCoaFileApi({ uploadUrl: config.uploadUrl, file });
  return config;
};
